import React, { Component } from "react";
import "../css/favoritePlans.css";
import Favorite from './Favorite';
import { Link } from "react-router-dom";
import { FaTimes } from 'react-icons/fa';

import ReactGA from 'react-ga';


class FavoriteLinks extends Component {

    constructor(props) {
        super(props);
        this.state = {
            favorites: [],
            email: ""
        }
    }

    render() {
        return (
            <div style={{ paddingTop: "45px", paddingBottom: "20px" }}>
                <div className="topBar">
                    <Link className="topBarBackButton" to="/webapp">
                        <FaTimes />
                    </Link>
                    <div className="topBarTitle">Favorites List</div>
                </div>
                {this.state.favorites}
            </div>
        );
    }

    getFavoritePlans = (favorites) => {
        if (!!favorites) {
            var url = "https://www.houseplanstore.com/web_api/?v=getFavoritePlans&planIds=" + favorites;
            //console.log(url)
            var xhr = new XMLHttpRequest();
            xhr.open("GET", url, true);
            xhr.onload = function (e) {
                try {
                    ///console.log(xhr.responseText);
                    if (xhr.responseText == "" || xhr.responseText == "null") {
                        return;
                    }
                    var json = JSON.parse(xhr.responseText);
                    var favoriteDataItems = [];
                    for (var i = 0; i < Object.keys(json).length; i++) {
                        favoriteDataItems.push(<Favorite key={i}  type="linkList" item={json[i]} />);
                    }
                    //console.log(dataItems);
                    this.setState({
                        favorites: [...this.state.favorites, ...favoriteDataItems]
                    })
                } catch (err) {
                    console.log(err);
                }
            }.bind(this)
            xhr.send();
        }
    }

    getUrlVars = () => {
        var vars = {};
        var parts = window.location.href.replace(/[?&]+([^=&]+)=([^&]*)/gi, function (m, key, value) {
            vars[key] = value;
        });
        return vars;
    }

    componentDidMount() {

        if (!!this.getUrlVars()["planIds"]) {
            //make sure there's a trailing comma in case it was removed by the email client
            var favorites = this.getUrlVars()["planIds"];
            favorites = favorites + ",";
            favorites = favorites.replace(",,", ",");
            this.getFavoritePlans(favorites);
        }

        ReactGA.pageview('/webapp/favorite_links/');

    }
}

export default FavoriteLinks;